<template>
  <div class="data-monitor">
	  <div class="headCarName">
		 <i class="el-icon-setting"></i>&nbsp;&nbsp;数据监控&nbsp;&nbsp;&nbsp;&nbsp;<font size="2px">当前车辆ID：{{mycarId}}</font>
	  </div>
	  <!-- 主内容模块 -->
	  <div class="span12" style="margin-top:20px;">
		  <el-row>
		    <el-col :span="8"><div class="grid-content bg-purple">
		  		<label class="col-sm-2 control-label" style="line-height:33px;font-size:20px;float:left;">在线总时长：{{totaltime}}分钟</label>
		  		</div></el-col>
		    <el-col :span="10"><div class="grid-content bg-purple-light">
		  		<div class="content">
		  			   <label class="jelabel" style="display:block;float:left;font-size:20px;line-height:33px;">时间选择：</label>
		  		  </div>
		  		  <el-date-picker
		  		        v-model="timevalue"
		  		        type="date"
						value-format="yyyy-MM-dd"
		  		        placeholder="选择时间">
		  		      </el-date-picker>
		  		<el-button class="filter-item" type="primary" plain icon="el-icon-search" style="margin-left: 10px" @click="dateTimeSearchBtn">
		  		  搜索
		  		</el-button>
		  		</div></el-col>
		    <el-col :span="6"><div class="grid-content bg-purple">
		  		<el-button class="filter-item" type="danger" plain icon="el-icon-delete" style="margin-left: 140px" @click="clearData">
		  		  清空
		  		</el-button>
		  		<el-button class="filter-item" type="success" plain icon="el-icon-s-order" style="margin-left: 20px" @click="showDataMonitorInfo">
		  		  详情
		  		</el-button>
		  		</div></el-col>
		  </el-row>
	  </div>

	  <!-- 数据列表区 -->
	  <div style="margin-top:20px;margin-left:0px;text-align:center;padding:10px 0;height:120px;">
		  <div class="joy" style="width:100%;height:100px;text-align:center;">
			  <el-table
			    :data="listData"
			    v-loading="listLoading"
			    border
			    highlight-current-row
			    style="width: 100%;align: center;">

			    <el-table-column prop="carIdStr" label="车辆ID" align="center">
			    </el-table-column>
			    <el-table-column prop="carName" label="车辆名称" align="center">
			    </el-table-column>
			    <el-table-column prop="carStatus" label="车辆状态" align="center">
			    </el-table-column>
			    <el-table-column prop="carPower" label="电量"  align="center">
			    </el-table-column>
			    <el-table-column prop="carVol" label="电压" align="center">
			    </el-table-column>
			    <el-table-column prop="carEle" label="电流" align="center">
			    </el-table-column>
			    <el-table-column prop="carUlt1" label="超声波(前-左)" align="center">
			    </el-table-column>
			    <el-table-column prop="carUlt2" label="超声波(前-右)" align="center">
			    </el-table-column>
			    <el-table-column prop="carUlt3" label="超声波(后-左)" align="center">
			    </el-table-column>
			    <el-table-column prop="carUlt4" label="超声波(后-右)" align="center">
			    </el-table-column>
			  		<el-table-column prop="carUlt5" label="超声波(左-上)" align="center">
			  		</el-table-column>
			  		<el-table-column prop="carUlt6" label="超声波(左-下)" align="center">
			  		</el-table-column>
			  		<el-table-column prop="carUlt7" label="超声波(右-上)" align="center">
			  		</el-table-column>
			  		<el-table-column prop="carUlt8" label="超声波(右-下)" align="center">
			  		</el-table-column>
			  		<el-table-column prop="carErrorCode" label="故障码" align="center">
			  		</el-table-column>
			  </el-table>
			  </div>

	  </div>

	  <!-- 图表区 -->
	   <div class="span12" style="margin-top:10px;margin-left:0px;border:1px solid #DCDCDC;text-align:center;height:330px;">
	       <!-- 统计数据模块(在线时长、超声波值) -->

		   <el-row>
		     <el-col :span="12">
				 <div class="grid-content bg-purple">
			 <div id="onlineTime" style="width: 100%;height:300px;"></div>
			 </div></el-col>
		     <el-col :span="12"><div class="grid-content bg-purple-light">
			 <div id="ultData" style="width: 100%;height:300px;"></div>
			 </div></el-col>
		   </el-row>
	  	</div>

		 <div class="span12" style="margin-top:10px;margin-left:0px;border:1px solid #DCDCDC;text-align:center;height:230px;">
			 <!-- 统计数据模块(电量、电压、电流值) -->
			 <el-row>
			   <el-col :span="8"><div class="grid-content bg-purple">
			   <div id="powerData" style="width: 100%;height:200px;"></div>
			   </div></el-col>
			   <el-col :span="8"><div class="grid-content bg-purple-light">
			   <div id="volData" style="width: 100%;height:200px;"></div>
			   </div></el-col>
			   <el-col :span="8"><div class="grid-content bg-purple">
			   <div id="eleData" style="width: 100%;height:200px;"></div>
			   </div></el-col>
			 </el-row>
		</div>

  </div>
</template>

<script>
import echarts from 'echarts'
import {getTotaltime} from '@/api/car.js'
import {getEchartDataMonitor} from '@/api/car.js'
import {getOnlineByIdTime} from '@/api/car.js'
import {getCarById} from '@/api/car.js'

export default {
  name: 'DataMonitor',
  data(){
	  return{
		  listLoading:false,
		  listData:[
			  {
			  carIdStr:'0',
			  carName:'0',
			  carStatus:'在线',
			  carPower:'0%',
			  carVol:'0V',
			  carEle:'0A',
			  carUlt1:'0cm',
			  carUlt2:'0cm',
			  carUlt3:'0cm',
			  carUlt4:'0cm',
			  carUlt5:'0cm',
			  carUlt6:'0cm',
			  carUlt7:'0cm',
			  carUlt8:'0cm',
			  carErrorCode:'无故障',
		  },
		  ],
		  mycarId:localStorage.getItem('monitorCarId'),
		  // 获取在线总时间
		  totaltime:'',
		  // 时间组件获取值
		  timevalue:'',
		  dateList:[],
		  beforeDate:'',
		  startDate:'',
		  dataMonitorReq:{
			  carId:'',
			  dateList:'',
		  },
		  // 图表操作 基础图表
		  option:{
		  		  title:{
		  			  text:'电量'
		  		  },
		  		  tooltip:{
		  			  trigger: 'axis'
		  		  },
		  		  legend: {
		  			  data: ['电量'],
		  			  },
		  		  xAxis:{
		  			  data:[]
		  		  },
		  		  yAxis:{
		  			  splitLine:{
		  				  show:false
		  			  }
		  		  },
		  		  grid:{
		  			   left: '3%',
		  			   right: '4%',
		  			   bottom: '3%',
		  			   containLabel: true
		  		  },
		  		  dataZoom:[{
		  			  startValue:'2020-08-01'
		  			  },{
		  				  type:'inside'
		  			  }
		  		  ],
		  		  series:[{
		  			  name:'电流',
		  			  type:'line',
		  			  data:[],
		  			  markLine:{
		  				  silent:true,
		  				  data:[{
		  					  yAxis:50
		  				  },{
		  					  yAxis:100
		  				  },{
		  					  yAxis: 150
		  				  },{
		  					  yAxis: 200
		  				  },{
		  					  yAxis: 300
		  				  }]
		  			  }
		  		  }]

		  },
		  option2:{},
		  dataMonitorInterval:undefined,
	  }
  },
  methods:{
	  /**
	   * 获取在线总时间
	   */
	  getDataMonitorTotalTime(carId){
		  //获取累计在线时长
		  getTotaltime(carId).then(res=>{
			  this.totaltime=res;
		  })

	  },
	  /**
	   * 获取往前推算30天的日期集合
	   */
	  getDateList(){
		  //组装日期数组用于每日在线时长统计
		  this.dateList=[];
		  for(let i=30;i>=0;i--){
			  this.dateList.push(this.getBeforeDate(i));
		  }
	  },
	  /**
	   * 获取当前日期的前n天的日期值
	   */
	  getBeforeDate(n){
		  let dateStr = this.timevalue;
		  dateStr = dateStr.replace(/-/g, '/');
		  let date = new Date(dateStr);
		  date.setDate(date.getDate() - n);
		  return this.dateFormat("YYYY-mm-dd", date);
	  },
	  /**
	   * 日期格式化
	   * @param {Object} fmt
	   * @param {Object} date
	   */
	  dateFormat(fmt, date){
		  let ret;
		  date=new Date(date);
		  	    const opt = {
		  	        "Y+": date.getFullYear().toString(),        // 年
		  	        "m+": (date.getMonth() + 1).toString(),     // 月
		  	        "d+": date.getDate().toString(),            // 日
		  	        "H+": date.getHours().toString(),           // 时
		  	        "M+": date.getMinutes().toString(),         // 分
		  	        "S+": date.getSeconds().toString()          // 秒
		  	        // 有其他格式化字符需求可以继续添加，必须转化成字符串
		  	    };
		  	    for (let k in opt) {
		  	        ret = new RegExp("(" + k + ")").exec(fmt);
		  	        if (ret) {
		  	            fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
		  	        };
		  	    };
		  	    return fmt;
	  },
	  /**
	   * 时间搜索按钮事件处理
	   */
	  dateTimeSearchBtn(){
		  // 日期处理开始
		  this.beforeDate= this.getBeforeDate(30);
		  // 组装日期数组用于每日在线时长统计
		  this.getDateList();
		  // 日期处理结束
		  this.setChartData();
		  this.setOnlineTimeChart();
	  },
	  /**
	   * 图表相关方法
	   * 基于准备好的dom，初始化echarts实例
	   */
	  setChartData(){
		  let time=this.timevalue;
		  getEchartDataMonitor(this.mycarId,time).then(res=>{
			  let resList=res.lst;
			  let dataList=new Array;// 时间
			  let valueList1 = new Array; //电流
			  let valueList2 = new Array; //电压
			  let valueList3 = new Array;//电量
			  let valueList4_1 = new Array;//超声波1
			  let valueList4_2 = new Array;//超声波2
			  let valueList4_3 = new Array;//超声波3
			  let valueList4_4 = new Array;//超声波4
			  let valueList4_5 = new Array;//超声波5
			  let valueList4_6 = new Array;//超声波6
			  let valueList4_7 = new Array;//超声波7
			  let valueList4_8 = new Array;//超声波8
			  for(let i=0;i<resList.length;i++){
				  dataList.push(this.dateFormat("YYYY-mm-dd HH:MM:SS", resList[i].createTime));
          console.log(resList);
				  valueList1.push(resList[i].powerLeft);
				  valueList2.push(resList[i].voltage);
				  valueList3.push(resList[i].electric);
				  valueList4_1.push(resList[i].ultrasonic1);
				  valueList4_2.push(resList[i].ultrasonic2);
				  valueList4_3.push(resList[i].ultrasonic3);
				  valueList4_4.push(resList[i].ultrasonic4);
				  valueList4_5.push(resList[i].ultrasonic5);
				  valueList4_6.push(resList[i].ultrasonic6);
				  valueList4_7.push(resList[i].ultrasonic7);
				  valueList4_8.push(resList[i].ultrasonic8);
			  }
			  let powerDataChart=echarts.init(document.getElementById('powerData'));
			  powerDataChart.setOption(this.option);
			  powerDataChart.setOption({
				  title:{
					  text:'电量(%)'
				  },
				  legend:{
					  data:['电量']
				  },
				  xAxis:{
					  data:dataList
				  },
				  series:[{
					  name:'电量',
					  type:'line',
					  data:valueList1,
					  markLine:{
						  silent:true,
						  data:[{
							  yAxis:5
						  },{
							  yAxis: 10
						  },{
							  yAxis: 15
						  },{
							  yAxis: 20
						  },{
							  yAxis: 30
						  }]
					  }
				  }]
			  });
			  window.onresize = powerDataChart.resize;//图表自适应浏览器

			  //电压图表
			  let volDataChart=echarts.init(document.getElementById('volData'));
			  volDataChart.setOption(this.option);
			  volDataChart.setOption({
			  				  title:{
			  					  text:'电压(V)'
			  				  },
			  				  legend:{
			  					  data:['电压']
			  				  },
			  				  xAxis:{
			  					  data:dataList
			  				  },
			  				  series:[{
			  					  name:'电压',
			  					  type:'line',
			  					  data:55,
			  					  markLine:{
			  						  silent:true,
			  						  data:[{
			  							  yAxis:5
			  						  },{
			  							  yAxis: 10
			  						  },{
			  							  yAxis: 15
			  						  },{
			  							  yAxis: 20
			  						  },{
			  							  yAxis: 30
			  						  }]
			  					  }
			  				  }]
			  });
			  window.onresize = volDataChart.resize;//图表自适应浏览器

			  // 电流图表
			  let eleDataChart = echarts.init(document.getElementById('eleData'));
			  eleDataChart.setOption(this.option);
			  eleDataChart.setOption({
			  				  title:{
			  					  text:'电流(A)'
			  				  },
			  				  legend:{
			  					  data:['电流']
			  				  },
			  				  xAxis:{
			  					  data:dataList
			  				  },
			  				  series:[{
			  					  name:'电流',
			  					  type:'line',
			  					  data:valueList3,
			  					  markLine:{
			  						  silent:true,
			  						  data:[{
			  							  yAxis:5
			  						  },{
			  							  yAxis: 10
			  						  },{
			  							  yAxis: 15
			  						  },{
			  							  yAxis: 20
			  						  },{
			  							  yAxis: 30
			  						  }]
			  					  }
			  				  }]
			  });
			  window.onresize = eleDataChart.resize;//图表自适应浏览器

			  // 超声波图表
			  let ultDataChart = echarts.init(document.getElementById('ultData'));
			  ultDataChart.setOption(this.option);
			  ultDataChart.setOption({
			  				  title:{
			  					  text:'超声波(cm)'
			  				  },
			  				  legend:{
								  x:'150px',
								  y:'0px',
			  					  data:['前-左', '前-右', '后-左', '后-右', '左-上', '左-下', '右-上', '右-下']
			  				  },
			  				  xAxis:{
			  					  data:dataList
			  				  },
			  				  series:[{
			  					  name:'前-左',
			  					  type:'line',
			  					  data:valueList4_1,
			  					  markLine:{
			  						  silent:true,
			  						  data:[{
			  							  yAxis:100
			  						  },{
			  							  yAxis: 200
			  						  },{
			  							  yAxis: 300
			  						  },{
			  							  yAxis: 400
			  						  },{
			  							  yAxis: 500
			  						  }]
			  					  }
			  				  },{
								name:'前-右',
								type:'line',
								data:valueList4_2,
								markLine:{
									silent:true,
									data:[{
							  	    yAxis:100
							      },{
							  	    yAxis: 200
							      },{
							  	    yAxis: 300
							      },{
							  	    yAxis: 400
							      },{
							  	    yAxis: 500
							      }]
								}
							  },{
								name:'后-左',
								type:'line',
								data:valueList4_3,
								markLine:{
									silent:true,
									data:[{
								    yAxis:100
								  },{
								    yAxis: 200
								  },{
								    yAxis: 300
								  },{
								    yAxis: 400
								  },{
								    yAxis: 500
								  }]
								}
							  },{
								name:'后-右',
								type:'line',
								data:valueList4_4,
								markLine:{
									silent:true,
									data:[{
								    yAxis:100
								  },{
								    yAxis: 200
								  },{
								    yAxis: 300
								  },{
								    yAxis: 400
								  },{
								    yAxis: 500
								  }]
								}
							  },{
								 name:'左-上',
								 type:'line',
								 data:valueList4_5,
								 markLine:{
								 	silent:true,
								 	data:[{
								     yAxis:100
								   },{
								     yAxis: 200
								   },{
								     yAxis: 300
								   },{
								     yAxis: 400
								   },{
								     yAxis: 500
								   }]
								 }
							  },{
								 name:'左-下',
								 type:'line',
								 data:valueList4_6,
								 markLine:{
								 	silent:true,
								 	data:[{
								     yAxis:100
								   },{
								     yAxis: 200
								   },{
								     yAxis: 300
								   },{
								     yAxis: 400
								   },{
								     yAxis: 500
								   }]
								 }
							  },{
								name:'右-上',
								type:'line',
								data:valueList4_7,
								markLine:{
									silent:true,
									data:[{
								    yAxis:100
								  },{
								    yAxis: 200
								  },{
								    yAxis: 300
								  },{
								    yAxis: 400
								  },{
								    yAxis: 500
								  }]
								}
							  },{
								  name:'右-下',
								  type:'line',
								  data:valueList4_8,
								  markLine:{
								  	silent:true,
								  	data:[{
								      yAxis:100
								    },{
								      yAxis: 200
								    },{
								      yAxis: 300
								    },{
								      yAxis: 400
								    },{
								      yAxis: 500
								    }]
								  }
							  }]
			  });
			  window.onresize = eleDataChart.resize;//图表自适应浏览器
		  })
	  },

	  setOnlineTimeChart(){
		  this.dataMonitorReq.carId=this.mycarId;
		  this.dataMonitorReq.dateList=this.dateList;
		  this.option2={
			  title:{
				  text:'每日在线时间统计'
			  },
			  tooltip:{},
			  legend:{
				  data:['时长'],
			  },
			  xAxis:{
				  data:[]
			  },
			  yAxis:{},
			  series:[{
				  name:'时长',
				  type:'bar',
				  data:[]
			  }]
		  };
		  getOnlineByIdTime(this.dataMonitorReq).then(res=>{
			  // 在线时长统计
			  console.log(this.dateList);
			  let onlineTimeChart = echarts.init(document.getElementById('onlineTime'));
			  if(res.data==null){
				  onlineTimeChart.setOption(this.option2);
			  }else{
				  onlineTimeChart.setOption({
					  title:{
						  text:'每日在线时间统计(分钟)'
					  },
					  tooltip:{},
					  legend:{
					  		data:['时长']
					  },
					  grid:{
						  x:"40",
						  width:"90%",
						  height:"70%"// 高度
					  },
					  xAxis:{
					  		data:this.dateList
					  },
					  yAxis:{},
					  series:[{
					  	  name:'时长',
					  	  type:'bar',
					  	  data:res.data,
					  }]
				  });
				  window.onresize = onlineTimeChart.resize;//图表自适应浏览器
			  }
		  })
	  },

	  /**
	   * 获取当前日期
	   */
	  getNowDate(){
		  let date=new Date();
		  let seperator1="-";
		  let month = date.getMonth() + 1<10? "0"+(date.getMonth() + 1):date.getMonth() + 1;
		  let strDate = date.getDate()<10? "0" + date.getDate():date.getDate();
		  let currentdate = date.getFullYear() + seperator1  + month  + seperator1  + strDate;
		  this.beforeDate=currentdate;
		  this.startDate=currentdate;
	  },
	  getNowTime() {
	         var now = new Date();
	         var year = now.getFullYear(); //得到年份
	         var month = now.getMonth(); //得到月份
	         var date = now.getDate(); //得到日期
	         month = month + 1;
	         month = month.toString().padStart(2, "0");
	         date = date.toString().padStart(2, "0");
	         var defaultDate = `${year}-${month}-${date}`;
			 this.timevalue=defaultDate;
	         // this.$set(this.searchFormField, "date", defaultDate);
	     },
	  /**
	   * 获取小车信息
	   */
	  getCarInfo(){
		  getCarById(this.mycarId).then(res => {
		    let data = res.data
		    // 对后端数据进行解析
		    this.listData = data.map(item => {
		      return {
		        carIdStr: item.idStr,
		  		carName:item.name,
		        carStatus: item.statusStr,
		        carPower: item.powerLeft+"%",
		        carVol: item.voltage+"V",
		        carEle: item.electric+"A",
		        carUlt1: item.ultrasonic1+"cm",
		        carUlt2: item.ultrasonic2+"cm",
		        carUlt3: item.ultrasonic3+"cm",
		        carUlt4: item.ultrasonic4+"cm",
				carUlt5: item.ultrasonic5+"cm",
				carUlt6: item.ultrasonic6+"cm",
				carUlt7: item.ultrasonic7+"cm",
				carUlt8: item.ultrasonic8+"cm",
				carErrorCode:item.troubleStr,
		      }
		    })
		    this.listLoading = false
		  })
	  },
	  /**
	   * 跳转到详情页面
	   */
	  showDataMonitorInfo(){
	  	this.$router.push({
	  		name:'data_monitor_info',
	      });
	  	localStorage.setItem('monitorInfoCarId',this.mycarId);
		localStorage.setItem('monitorInfoTime',this.timevalue);
	  },
	  //清空数据
	  clearData(){

	  },
	  checkLeave(){
	      clearInterval(this.dataMonitorInterval);
		  console.log("离开数据监控页面");
	  },
	  },
	  beforeDestroy(){
	      this.checkLeave()
	  },
	  destroyed(){
	       window.removeEventListener('beforeunload', this.checkLeave)
	  },
	  mounted() {
		this.getNowTime();
		this.setChartData();
	  	this.getDataMonitorTotalTime(localStorage.getItem('monitorCarId'));
		this.getNowDate();
		this.getCarInfo();
		let that=this
		this.dataMonitorInterval=setInterval(function(){
			that.getCarInfo(that.mycarId);
		},60000);
		this.getDateList();
		this.setOnlineTimeChart();
		window.addEventListener('beforeunload', this.checkLeave)
	  }

}
</script>

<style>
.headCarName{
	background-color:#3fb976;
	width:100%;
	height:50px;
	color:#FFFFFF;
	line-height:50px;
	padding-left: 15px;
	border-radius: 10px;
}
</style>
